import React, { useState } from 'react';
import { Chip, Typography, RadioGroup, Radio, FormControlLabel } from '@mui/material';
import { refactorPriceRange } from '../../utils/_helpers';
import { BasePopup, ConfirmButton, PopupSubtitle } from './BasePopup.jsx';
import { SelectApproverAutocomplete } from './SelectApproverAutocomplete.jsx';
import { SelectOrderCategoryAutocomplete } from './SelectOrderCategoryAutocomplete.jsx';
import { SelectAgentAutocomplete } from './SelectAgentAutocomplete.jsx';

// prettier-ignore
export const AddDialog = ({ open, title, handleCloseDialog, handleAddApprover, itemDescription, itemId, childAccordionDetails, context }) => {
const getOptions = context.get('get options');
	const [selectedOrderCategory, setSelectedOrderCategory] = useState();
	const [selectedApprover, setSelectedApprover] = useState();

	  const typeOptions = [
          { label: 'User', value: 'US' },
          { label: 'Position', value: 'S' },
      ];
	  const [type,setType] = useState(typeOptions[0].value);
	const costCenterLabel = itemDescription ? `${itemId} - ${itemDescription}` : itemId;
	const bandLabel = childAccordionDetails.PriceRange ? `${refactorPriceRange(childAccordionDetails.PriceRange)} (${childAccordionDetails.RelGroup}/${childAccordionDetails.RelCode})` : `${childAccordionDetails.RelGroup}/${childAccordionDetails.RelCode}`;
	const operation = context.get('Operation');



	return (
        <BasePopup
            title="Add Approver"
            content={
                <div>
                    <PopupSubtitle subtitle={title} />
                    <Chip color="primary" sx={{ marginBottom: '1vh' }} label={costCenterLabel} />
                    <PopupSubtitle subtitle="Band" />
                    <Chip color="primary" label={bandLabel} sx={{ marginBottom: '1vh' }} />
                    {operation !== 'PO' && (
                        <div>
                            <PopupSubtitle subtitle="Order Category" />
                            <SelectOrderCategoryAutocomplete
                                context={context}
                                selectedOrderCategory={selectedOrderCategory}
                                setSelectedOrderCategory={setSelectedOrderCategory}
                            />
                        </div>
                    )}
                    <div>
                        <div
                            className="edit-agent-responsibility-form"
                            style={{ display: 'flex', flexDirection: 'column' }}
                        >
                            <div>
                                <Typography variant="caption">Type</Typography>
                                <RadioGroup
                                    row
                                    name="row-radio-buttons-group"
                                    value={type ?? typeOptions[0].value}
                                    onChange={(event, value) => {
                                        setType(value ?? '');
                                        setSelectedApprover(null);
                                    }}
                                >
                                    {typeOptions.map((option) => (
                                        <FormControlLabel
                                            key={option.value}
                                            value={option.value}
                                            control={<Radio />}
                                            label={option.label}
                                        />
                                    ))}
                                </RadioGroup>
                            </div>
                            {type === 'US' ? (
                                <div>
                                    {!selectedApprover && <Typography variant="caption">New User</Typography>}
                                    <SelectApproverAutocomplete
                                        context={context}
                                        selectedApprover={selectedApprover}
                                        setSelectedApprover={setSelectedApprover}
                                    />
                                </div>
                            ) : null}
                            {type === 'S' ? (
                                <div>
                                    {!selectedApprover && <Typography variant="caption">New Position</Typography>}
                                    <SelectAgentAutocomplete
                                        context={context}
                                        getOptions={getOptions}
                                        selectedApprover={selectedApprover}
                                        setSelectedApprover={setSelectedApprover}
                                        path={'PositionIdSet'}
                                        filter={(value) => `IdNo eq '01' and SearchTerm eq '${value}'`}
                                    />
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            }
            button={
                <ConfirmButton
                    text="Send Approver Request"
                    onClick={handleAddApprover(selectedApprover, selectedOrderCategory, type)}
                />
            }
            handleCloseDialog={handleCloseDialog}
        />
    );
}
